import { useApi } from '@/composables/api.ts'
import type { GenericFolder } from '@deepcloud/api-deep-box'

export function useBoxGeneric() {
  const { t } = useI18n()
  const { deepBoxAPI } = useApi()

  function getGenericsTitleByGenericId(genericFolder: GenericFolder) {
    switch (genericFolder.id) {
      case 'deepmail':
        return t('box.private.generics.deepmail.title')
      case 'deepsign':
        return t('box.private.generics.deepsign.title')

      default:
        return genericFolder.displayName
    }
  }

  async function onFetchGenericFolders(typeId: string, boxId: string) {
    try {
      const res = await deepBoxAPI.value.deepBoxesBoxesGenerics.get(
        typeId,
        boxId,
      )

      return res.data.map((r) => {
        return {
          ...r,
          displayName: getGenericsTitleByGenericId(r),
        }
      })
    } catch (e) {
      console.error(e)
    }
  }

  return {
    onFetchGenericFolders,
  }
}
